export default __webpack_public_path__ + "static/media/Rarify Community.5ed88b56.svg";